import request from '@/utils/request'
import { downloadBlob } from '@/utils/download'

const apiPath = '/outbound'

// ==================== 出库商品 API ====================

/**
 * 商品分页列表
 */
export function getGoodsPage(query) {
  return request({
    url: apiPath + '/goods/page',
    method: 'get',
    params: query
  })
}

/**
 * 商品详情
 */
export function getGoodsDetail(id) {
  return request({
    url: apiPath + '/goods/' + id,
    method: 'get'
  })
}

/**
 * 新增商品
 */
export function addGoods(data) {
  return request({
    url: apiPath + '/goods',
    method: 'post',
    data
  })
}

/**
 * 修改商品
 */
export function updateGoods(data) {
  return request({
    url: apiPath + '/goods',
    method: 'put',
    data
  })
}

/**
 * 删除商品
 */
export function deleteGoods(id) {
  return request({
    url: apiPath + '/goods/' + id,
    method: 'delete'
  })
}

/**
 * 上下架
 */
export function updateGoodsState(id, state) {
  return request({
    url: apiPath + '/goods/state/' + id,
    method: 'put',
    params: { state }
  })
}

/**
 * 手动同步库存
 */
export function syncGoodsInventory(skuCodes) {
  return request({
    url: apiPath + '/goods/syncInventory',
    method: 'post',
    data: { skuCodes }
  })
}

/**
 * 手动同步商品信息
 */
export function syncGoodsInfo(skuCodes) {
  return request({
    url: apiPath + '/goods/syncInfo',
    method: 'post',
    data: { skuCodes }
  })
}

/**
 * 下载导入模板
 */
export function downloadGoodsTemplate() {
  return request({
    url: apiPath + '/goods/template',
    method: 'get',
    responseType: 'blob'
  }).then(res => downloadBlob(res, '出库商品导入模板.xlsx'))
}

// ==================== 出库订单 API ====================

/**
 * 订单分页列表
 */
export function getOrderPage(query) {
  return request({
    url: apiPath + '/order/page',
    method: 'get',
    params: query
  })
}

/**
 * 订单详情
 */
export function getOrderDetail(id) {
  return request({
    url: apiPath + '/order/' + id,
    method: 'get'
  })
}

/**
 * 创建订单
 */
export function createOrder(data) {
  return request({
    url: apiPath + '/order/create',
    method: 'post',
    data
  })
}

/**
 * 推送订单到聚水潭
 */
export function pushOrderToJst(id) {
  return request({
    url: apiPath + '/order/pushJst/' + id,
    method: 'post'
  })
}

/**
 * 取消订单
 */
export function cancelOrder(id) {
  return request({
    url: apiPath + '/order/cancel/' + id,
    method: 'post'
  })
}
